// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__7q8lX","footer_container":"Footer_footer_container__5SfZ6","footer_item":"Footer_footer_item__2prJe"};